import styled from "styled-components";
import "rrweb-player/dist/style.css";
import "./SessionReplay.css";

export const SessionReplayContainer = styled.div`
  margin-bottom: 4rem;
`;
